import { AdminUserPicker } from '../shared/pickers/AdminUserPicker';
import { AdminBrokerGroupPicker } from '../shared/pickers/AdminBrokerGroupPicker';
import { AdminLedgerPicker } from '../shared/pickers/AdminLedgerPicker';

/**
 * The lists a feature flag can target, keyed by the flag item field (and PATCH field) that
 * holds them: nouns for messages and the picker used to add to them.
 */
export const FEATURE_FLAG_TARGETS = {
	users: { noun: 'users', singular: 'user', Picker: AdminUserPicker },
	brokerGroups: { noun: 'broker groups', singular: 'broker group', Picker: AdminBrokerGroupPicker },
	ledgers: { noun: 'ledgers', singular: 'ledger', Picker: AdminLedgerPicker },
};
